import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ExpenseListComponent } from './expense-list/expense-list.component';
import { SharedModule } from "../../shared/shared.module";
import { CreateExpenseModalComponent } from './create-expense-modal/create-expense-modal.component';
import { EditExpenseModalComponent } from './edit-expense-modal/edit-expense-modal.component';
import { CheckExpenseModalComponent } from './check-expense-modal/check-expense-modal.component';
import { CheckExpenseClaimListModalComponent } from './check-expense-claim-list/check-expense-claim-list.component';
import { ExpenseCardComponent } from './expense-card/expense-card.component';
import { ExpenseCheckPreviewComponent } from './expense-check-preview/expense-check-preview.component';
import { ExpenseDetailsHeadComponent } from './expense-list/expense-details-head/expense-details-head.component';
import { ExpenseStateBadgeComponent } from './expense-list/expense-state-badge/expense-state-badge.component';
import { ExpenseMetaDataComponent } from './expense-list/expense-meta-data/expense-meta-data.component';
import { ExpenseCostComponent } from './expense-list/expense-cost/expense-cost.component';
import { ExpenseDescriptionComponent } from './expense-list/expense-description/expense-description.component';
import { ExpenseImagesComponent } from '../../shared/expense-images/expense-images.component';
import { ExpenseActionsComponent } from './expense-list/expense-actions/expense-actions.component';
import { ExpenseEditReasonsComponent } from './expense-list/expense-edit-reasons/expense-edit-reasons.component';
import { ExpenseRejectReasonComponent } from './expense-list/expense-reject-reason/expense-reject-reason.component';
import {
  ExpenseCaxtonDetailsHeadComponent
} from './expense-list/expense-caxton-details-head/expense-caxton-details-head.component';
import {
  ExpenseCaxtonPaymentDatesComponent
} from './expense-list/expense-caxton-payment-dates/expense-caxton-payment-dates.component';
import {
  ExpenseCaxtonPaymentActionsComponent
} from './expense-list/expense-caxton-payment-actions/expense-caxton-payment-actions.component';
import {
  ExpenseAutoApprovalResultComponent
} from './expense-list/expense-auto-approval-result/expense-auto-approval-result.component';
import { TrialModule } from '../trial/trial.module';
import { StartInvestigationModalComponent } from './start-investigation-modal/start-investigation-modal.component';
import { CloseInvestigationModalComponent } from './close-investigation-modal/close-investigation-modal.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import {
  ApprovedExpensesContainerComponent
} from './approved-expenses-container/approved-expenses-container.component';
import {
  OverBudgetCategoriesSelectModalComponent
} from './over-budget-categories-select-modal/over-budget-categories-select-modal.component';
import {
  OverBudgetRequestModalComponent
} from './expense-list/over-budget-request-modal/over-budget-request-modal.component';
import { ExpenseAddNotesComponent } from './expense-list/expense-add-notes/expense-add-notes.component';
import { ButtonComponent } from "../../shared/button/button.component";
import { PgoCallout } from "../../shared/pgo-callout/pgo-callout";
import { DuplicateExpenseModalComponent } from "./duplicate-expense-modal/duplicate-expense-modal.component";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxImageZoomModule } from "ngx-image-zoom";
import { ExpenseImageComponent } from "../../shared/expense-images/expense-image/expense-image.component";
import { ExpenseAiCategoryComponent } from "../../shared/expense-ai-category/expense-ai-category.component";
import { ExpenseAiAmountComponent } from "../../shared/expense-ai-amount/expense-ai-amount.component";
import { ExpenseAiReceiptDateComponent } from "../../shared/expense-ai-receipt-date/expense-ai-receipt-date.component";
import {
  ConfirmWipActionModalComponent
} from "./expense-list/expense-actions/confirm-wip-action-modal/confirm-wip-action-modal.component";
import {
  ExpenseApprovalChecksComponent
} from "./expense-list/expense-approval-checks/expense-approval-checks.component";
import { ExpenseFiltersComponent } from "./expense-list/expense-filters/expense-filters.component";
import { SplitButtonComponent } from "../../shared/split-button/split-button.component";

@NgModule({
  declarations: [
    ExpenseListComponent,
    CreateExpenseModalComponent,
    EditExpenseModalComponent,
    CheckExpenseModalComponent,
    CheckExpenseClaimListModalComponent,
    ExpenseCardComponent,
    ExpenseCheckPreviewComponent,
    ExpenseDetailsHeadComponent,
    ExpenseStateBadgeComponent,
    ExpenseMetaDataComponent,
    ExpenseCostComponent,
    ExpenseDescriptionComponent,
    ExpenseActionsComponent,
    ExpenseEditReasonsComponent,
    ExpenseRejectReasonComponent,
    ExpenseCaxtonDetailsHeadComponent,
    ExpenseCaxtonPaymentDatesComponent,
    ExpenseCaxtonPaymentActionsComponent,
    ExpenseAutoApprovalResultComponent,
    StartInvestigationModalComponent,
    CloseInvestigationModalComponent,
    ApprovedExpensesContainerComponent,
    OverBudgetCategoriesSelectModalComponent,
    OverBudgetRequestModalComponent,
    ExpenseAddNotesComponent,
    DuplicateExpenseModalComponent,
    ExpenseImagesComponent,
    ExpenseImageComponent,
    ExpenseAiCategoryComponent,
    ExpenseAiAmountComponent,
    ExpenseAiReceiptDateComponent,
    ConfirmWipActionModalComponent,
    ExpenseApprovalChecksComponent,
    ExpenseFiltersComponent
  ],
  exports: [
    EditExpenseModalComponent,
    CreateExpenseModalComponent,
    ExpenseCheckPreviewComponent,
    StartInvestigationModalComponent,
    CloseInvestigationModalComponent,
    DuplicateExpenseModalComponent,
    ExpenseImagesComponent,
    ExpenseImageComponent,
    ExpenseAiCategoryComponent,
    ExpenseAiAmountComponent,
    ExpenseAiReceiptDateComponent
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        RouterModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatInputModule,
        TrialModule,
        ButtonComponent,
        PgoCallout,
        NgxImageZoomModule,
        DecimalPipe,
        SplitButtonComponent
    ]
})
export class ExpenseModule { }
